import React from 'react'
import { useSelector } from 'react-redux'
import { MapSection, PartnerSection, ActionButtons, Sidebar } from '.'
import { Container } from '../../../components'
import Content from './default-content'

const MainContent = ({data}) => {
  const { isOfficial } = useSelector(state => state.account)
  const language = useSelector(state => state.system.language)
  const descriptionLanguage = data[`description_${language.name}`]
  const descriptionRendered = descriptionLanguage ? descriptionLanguage : ''
  const highlightLanguage = data[`highlight_${language.name}`]
  const highlightRendered = highlightLanguage ? highlightLanguage : ''
  const {
    image,
  } = data
  const {
    partners,
    partners_external
  } = useSelector(state => state.organization.data)

  return (
    <Container>
      {/* MOBILE - Action Buttons */}
      {
        !isOfficial &&
        <div className="lg:hidden">
          <ActionButtons isMobile/>
          <hr className="my-8"/>
        </div>
      }

      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-8/12 px-4">
          {
            image &&
            <img src={image} className="w-full rounded mb-5 lg:mb-8" alt={image} />
          }
          {
            highlightRendered &&
            <div
              className="mb-10 lg:mb-6 prose font-bold whitespace-pre-line"
              dangerouslySetInnerHTML={{__html: highlightRendered}}
            />
          }
          {
            descriptionRendered ? (
              <div
                className="mb-10 lg:mb-0 prose prose-sm whitespace-pre-line"
                dangerouslySetInnerHTML={{__html: descriptionRendered}}
              />
            ) : (<Content />)
          }
          <hr className="my-10 lg:my-16"/>
          <MapSection data={data}/>
          {
            isOfficial && (partners.length > 0 || partners_external.length > 0) &&
            <React.Fragment>
              <hr className="mb-8 lg:mb-16"/>
              <PartnerSection data={[...partners, ...partners_external]}/>
              <hr className="mt-5 mb-8 lg:hidden"/>
            </React.Fragment>
          }
        </div>
        <div className="w-full lg:w-3/12 px-4 pb-16 lg:pb-0 ml-auto">
          <Sidebar />
        </div>
      </div>

    </Container>
  )
}

export { MainContent }
